import { createContext } from 'react';

export interface TenantActionsValue {
  /** The tenant they were read for: the one the app is showing, or null. */
  tenantId: number | null;
  /** The actions the reader holds there; null while they are being read. */
  actions: ReadonlySet<string> | null;
}

export const TenantActionsContext = createContext<TenantActionsValue | null>(null);
